import React from 'react'

function Gap({height}) {
  return (
    <div style={{ height}}>
    </div>
  )
}

export default Gap